export const emailValidator = (value: string | undefined): string | undefined => {
  let error;

  if (value && value.indexOf('@') === -1) {
    error = 'Please enter a valid email address';
  }

  return error;
};
